<div class="item">
  <div class="item-top">
    <header class="item-header">
      <div class="item-img-wrapper">
        <a
          class="item-img-container"
          [routerLink]="'/' + shown().slug"
          routerLinkWithLang
          [class.item-img-container-with-hover]="!!shown().mediaHoverUrl"
        >
          <img
            class="item-img item-img-primary"
            [src]="setItemThumbnail()"
            [alt]="shown().name"
            loading="lazy"
          >
          @if (shown().mediaHoverUrl) {
            <img
              class="item-img item-img-secondary"
              [src]="shown().mediaHoverUrl"
              [alt]="shown().name"
              loading="lazy"
            >
          }

          @if (shown().label) {
            <span
              class="item-label"
              [class.item-label-new]="shown().label.type === ProductLabelTypeEnum.New"
              [class.item-label-top]="shown().label.type === ProductLabelTypeEnum.Top"
              [class.item-label-sale]="shown().label.type === ProductLabelTypeEnum.Sale"
            >
              {{ shown().label.text }}
            </span>
          }

          @if (shown().oldPrice) {
            <span class="item-sale-label">
              -{{ discountValue() }}%
            </span>
          }
        </a>

        <button
          class="item-wishlist"
          (click)="toggleWishlistFlag()"
        >
          <tc-icon
            class="item-wishlist-icon"
            [name]="wishlistService.isInWishlist(shown().id) ? 'heart-filled' : 'heart'"
          />
        </button>
      </div>
      <h2
        class="item-name"
        [class.item-name-compact]="isInListGrid()"
      >
        <a
          class="g-main-link g-main-link-black"
          [routerLink]="'/' + shown().slug"
          routerLinkWithLang
        >
          {{ shown().name }}
        </a>
      </h2>
    </header>

    @if (variantGroups().length) {
      <product-variants
        class="item-variants"
        [variantGroups]="variantGroups()"
        [moreSlug]="shown().slug"
        (variantHover)="hoveredVariant.set($event)"
      />
    }
  </div>

  <div class="item-bottom">
    @if (shown().reviewsInfo.allReviewsCount > 0) {
      <a
        class="item-rating"
        [routerLink]="'/' + shown().slug"
        routerLinkWithLang
        fragment="reviews"
      >
        <rating-stars
          class="item-rating-cmp"
          [rating]="shown().reviewsInfo.avgRating"
          [isDisabled]="true"
          [isSmall]="true"
        />
        <span class="item-rating-count">{{ shown().reviewsInfo.allReviewsCount }}</span>
      </a>
    }

    @if (!shown().reviewsInfo.allReviewsCount) {
      <div class="item-rating-placeholder"></div>
    }

    @if (error(); as errorValue) {
      <div class="item-error">
        {{ errorValue }}
      </div>
    }

    <div class="item-info">
      <div class="item-price-container">
        <div
          class="item-price"
          [class.item-price-special]="shown().oldPrice"
          [class.item-price-inactive-small]="activePriceIndex() !== undefined"
        >
          @if (shown().isAggregator) {
            <span class="item-from">
              {{ 'global.from' | translate }}
            </span>
          }
          {{ shown().price }}
          <span class="item-currency">
            {{ 'global.uah' | translate }}
          </span>
        </div>

        @if (shown().oldPrice; as oldPrice) {
          <div class="item-old-price">
            @if (shown().isAggregator) {
              <span>
                {{ 'global.from' | translate }}
              </span>
            }
            {{ oldPrice }}
            <span class="item-currency">{{ 'global.uah' | translate }}</span>
          </div>
        }
      </div>

      <div class="item-actions">
        @if (shown().isAggregator) {
          <a
            class="g-btn item-buy item-buy-aggregator"
            [routerLink]="'/' + shown().slug"
            routerLinkWithLang
            fragment="details"
          >
            {{ 'product_list_item.more' | translate }}
          </a>

        } @else if (cartService.isInCart(shown().id)) {
          <button
            class="g-btn item-buy"
            (click)="openCart()"
          >
            <tc-icon
              class="item-buy-icon"
              name="cart-filled"
            />
            {{ 'global.in_cart' | translate }}
          </button>

        } @else if (shown().isInStock) {
          <button
            class="g-btn item-buy"
            [class.item-buy-loading]="isLoading()"
            [disabled]="isLoading()"
            (click)="addToCart()"
          >
            <tc-icon
              class="item-buy-icon"
              name="cart"
            />
            {{ 'global.to_buy' | translate }}

            @if (isLoading()) {
              <preloader class="item-preloader" />
            }
          </button>

        } @else {
          <span class="item-out-of-stock">
            {{ 'global.out_of_stock' | translate }}
          </span>
        }
      </div>
    </div>

    @if (!shown().oldPrice) {
      <product-discounts
        class="item-discounts"
        [discountedPrices]="shown().discountedPrices"
        [activeIndex]="activePriceIndex()"
        [isAggregator]="shown().isAggregator"
        [isCompact]="true"
      />
    }
  </div>
</div>
